import { Link } from "react-router-dom";
import { EfLogo } from "@/components/Logo";
import { Btn } from "@/components/ui";

export function NotFoundPage() {
  return (
    <div className="relative flex min-h-dvh flex-col items-center justify-center gap-6 overflow-hidden bg-ef-bg p-5 text-center">
      <div
        className="pointer-events-none absolute left-1/2 top-1/3 h-[400px] w-[600px] -translate-x-1/2"
        style={{ background: "radial-gradient(ellipse, rgba(34,197,176,0.07) 0%, transparent 70%)" }}
      />
      <div className="relative z-10 flex flex-col items-center gap-5">
        <EfLogo size="lg" to="/projects" />
        <div className="font-display text-[72px] font-bold leading-none tracking-[-0.04em]">
          <span className="ef-gradient-text">404</span>
        </div>
        <p className="max-w-sm text-sm text-ef-textDim">
          This page drifted off the timeline. Let&rsquo;s get you back to your workspace.
        </p>
        <div className="flex gap-2.5">
          <Link to="/projects">
            <Btn variant="primary" size="md">
              Back to projects
            </Btn>
          </Link>
          <Link to="/login">
            <Btn variant="secondary" size="md">
              Sign in
            </Btn>
          </Link>
        </div>
      </div>
    </div>
  );
}
